import React, { useEffect, useState } from 'react';
import fr from 'facet-rest';
import MetaTable from 'Components/UI/Meta/MetaTable';
import PropTypes from 'prop-types';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import Typography from 'Components/UI/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { CircularProgress } from '@material-ui/core';

const styles = theme => ({
  root: {
    padding: theme.spacing(0, 3, 3, 3),
  },
  title: {
    padding: theme.spacing(2, 0),
  },
  cell: {
    '& h5': {
      fontSize: theme.typography.fontSize1Rem,
      fontWeight: theme.typography.fontWeightRegular,
      padding: '0',
    },
  },
  head: {
    '& th': {
      backgroundColor: 'transparent',
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: theme.typography.fontSize1Rem,
    },
  },
  loadingTitle: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3),
  },
  loading: {
    padding: theme.spacing(0, 3, 3, 3),
  },
});

const LinkingEventsMetaTable = ({ resource, classes }) => {
  const [loading, setLoading] = useState(true);
  const [collection, setCollection] = useState();

  useEffect(() => {
    async function getLinkingEvents() {
      try {
        const linkingEventsCollection = await resource?.relationship(fr.relationships.linkingEvents.name)?.link('related')?.get();
        setCollection(linkingEventsCollection);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        displayErrorMessage(err, 'Failed to fetch linking events');
      }
    }

    getLinkingEvents();
  }, []);

  if (loading) {
    return (
      <div className={classes.loading}>
        <Typography
          className={classes.loadingTitle}
          color="primary"
          variant="h2"
        >
          Linking Events
        </Typography>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <Typography
        className={classes.title}
        color="primary"
        variant="h2"
      >
        Linking Events
      </Typography>
      <MetaTable
        collection={collection}
        tableMetaOverrideSetName="LinkingAttemptsBaseOverride"
        columns={[
          { name: 'timestamp', style: { maxWidth: '150px' } },
          { name: 'providerName' },
          { name: 'eventType' },
          { name: 'status' },
          { name: 'additionalStatus' },
          { name: 'reason' },
        ]}
        hasSortableColumns
        linkQueryParamName={'getFeatureToggles'}
        HeadProps={{
          className: classes.head,
        }}
        CellProps={{
          className: classes.cell,
        }}
        disablePagination
      />
    </div>
  );
};

LinkingEventsMetaTable.propTypes = {
  resource: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LinkingEventsMetaTable);
